<template>
  <div>
    <router-view />
    <NotificationContainer />
  </div>
</template>

<script setup>
import NotificationContainer from './components/NotificationContainer.vue'
</script>

<style>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
